export const imageLink = {
  favicon: "https://static.mazhou.cc/mazhou/favicon.ico",
  mazhouLogo: "https://static.mazhou.cc/mazhou/minApp/mazhou-logo.png",
  next: "https://static.mazhou.cc/mazhou/next.svg",
  phone: "https://static.mazhou.cc/mazhou/phone.png",
  phoneHeader: "https://static.mazhou.cc/mazhou/minApp/phone-header.png",
  phoneWrapper: "https://static.mazhou.cc/mazhou/phoneWrapper.png",
  prev: "https://static.mazhou.cc/mazhou/prev.svg",
  header: "https://static.mazhou.cc/mazhou/header.png",
  qrcodeTextPlaceholder:
    "https://static.mazhou.cc/mazhou/qrcode-placeholder.svg",
  qrcodePlaceholder: "https://static.mazhou.cc/mazhou/qrcode-show.svg",
  iconFileExcel: "https://static.mazhou.cc/mazhou/icon-file-excel.png",
  iconFileWrod: "https://static.mazhou.cc/mazhou/icon-file-word.png",
  iconFileTxt: "https://static.mazhou.cc/mazhou/icon-file-txt.png",
  iconFileImage: "https://static.mazhou.cc/mazhou/icon-file-image.png",
  iconFileOther: "https://static.mazhou.cc/mazhou/icon-file-other.png",
  iconFilePdf: "https://static.mazhou.cc/mazhou/icon-file-pdf.png",
  iconFilePpt: "https://static.mazhou.cc/mazhou/icon-file-ppt.png",
  authBg: "https://static.mazhou.cc/mazhou/auth-bg.png",
  qrcodeWrapper: "https://static.mazhou.cc/mazhou/qrcode-wrapper.png",
  wechat: "https://static.mazhou.cc/mazhou/wechat.png",
  bg: "https://static.mazhou.cc/mazhou/bg.png",
  logout: "https://static.mazhou.cc/mazhou/logout.png",
  audioIcon: "https://static.mazhou.cc/mazhou/audio-icon.png",
  uploadAudio: "https://static.mazhou.cc/mazhou/upload-audio.svg",
  book: "https://static.mazhou.cc/mazhou/book.png",
  book1: "https://static.mazhou.cc/mazhou/book1.png",
  book2: "https://static.mazhou.cc/mazhou/book2.png",
  book3: "https://static.mazhou.cc/mazhou/book3.png",
  book4: "https://static.mazhou.cc/mazhou/book4.png",
  book5: "https://static.mazhou.cc/mazhou/book5.png",
  book6: "https://static.mazhou.cc/mazhou/book6.png",
  qszz: "https://static.mazhou.cc/mazhou/qszz.png",
  xcc: "https://static.mazhou.cc/mazhou/xcc.png",
  uploadFile: "https://static.mazhou.cc/mazhou/minApp/upload-file.svg",
  uploadImage: "https://static.mazhou.cc/mazhou/minApp/upload-img.png",
  notice: "https://static.mazhou.cc/mazhou/notice.png",
  delete: "https://static.mazhou.cc/mazhou/delete.png",
  plus: "https://static.mazhou.cc/mazhou/plus.png",
  view: "https://static.mazhou.cc/mazhou/view.png",
  play: "https://static.mazhou.cc/mazhou/play.png",
  uploadVideo: "https://static.mazhou.cc/mazhou/minApp/upload-video.svg",
  priceBg: "https://static.mazhou.cc/mazhou/price-bg.png",
  c1: "https://static.mazhou.cc/mazhou/c1.png",
  c2: "https://static.mazhou.cc/mazhou/c2.png",
  chaozhi: "https://static.mazhou.cc/mazhou/chaozhi.png",
  g1: "https://static.mazhou.cc/mazhou/g1.png",
  g2: "https://static.mazhou.cc/mazhou/g2.png",
  g3: "https://static.mazhou.cc/mazhou/g3.png",
  g4: "https://static.mazhou.cc/mazhou/g4.png",
  websiteHomeBeautify:
    "https://static.mazhou.cc/mazhou/minApp/icon-beautify.svg",
  websiteHomeDecode: "https://static.mazhou.cc/mazhou/minApp/icon-decode.svg",
  websiteHomeMore: "https://static.mazhou.cc/mazhou/minApp/home-more.svg",
  websiteHomeNotice: "https://static.mazhou.cc/mazhou/minApp/home-notice.svg",
  websiteHomeUser: "https://static.mazhou.cc/mazhou/minApp/home-user.svg",
  ckVideo: "https://static.mazhou.cc/mazhou/minApp/ck-video.svg",
  ckAudio: "https://static.mazhou.cc/mazhou/minApp/ck-audio.svg",
  ckImage: "https://static.mazhou.cc/mazhou/minApp/ck-image.svg",
  audioEnterProgress: `https://static.mazhou.cc/mazhou/minApp/audio-enter-progress.png`,
  audioBackProgress: `https://static.mazhou.cc/mazhou/minApp/audio-back-progress.png`,
};
